import get from 'lodash.get';

const getDialogProps = (rootState) => get(rootState, 'dialogs.activeDialog.dialogProps', null);

export default getDialogProps;
